import React from 'react';
import {
  Input, Select, Row, Col,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Controller, useForm } from 'react-hook-form';
import AlumlyButton from '../../../components/AlumlyButton';

export type FilterFeaturedContentT = {
  searchQuery?: string;
  type?: string;
  status?: string;
};

interface FormFilterFeaturedContentListProps {
  selectedFilter: FilterFeaturedContentT | undefined;
  setSelectedFilter: React.Dispatch<React.SetStateAction<FilterFeaturedContentT | undefined>>;
}

const contentTypes = [
  { name: 'Event', value: 'event' },
  { name: 'News', value: 'news' },
];

const allStatus = [
  { name: 'Published', value: 'true' },
  { name: 'Draft', value: 'false' },
];

const FormFilterFeaturedContentList: React.FC<FormFilterFeaturedContentListProps> = (props) => {
  const { selectedFilter, setSelectedFilter } = props;

  const { control, reset } = useForm({
    defaultValues: {
      searchQuery: '',
      type: '',
      status: '',
    },
  });

  const handleSearch = (searchQuery: string): void => {
    setSelectedFilter({ ...selectedFilter, searchQuery });
  };

  const resetSearchAndFilter = (): void => {
    reset();
    setSelectedFilter({
      searchQuery: undefined,
      type: undefined,
      status: undefined,
    });
  };

  return (
    <div style={{
      padding: '16px 24px',
      marginTop: 24,
      background: 'white',
      border: '1px solid #E4E4E7',
      borderRadius: 12,
    }}
    >
      <Row gutter={16} align="middle">
        <Col xs={24} md={14}>
          <Controller
            name="searchQuery"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Input
                allowClear
                size="large"
                prefix={<SearchOutlined style={{ color: '#A1A1AA' }} />}
                placeholder="Search by title"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  handleSearch(e.target.value);
                }}
              />
            )}
          />
        </Col>
        <Col xs={24} md={6}>
          <Controller
            name="type"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Select
                size="large"
                style={{ width: '100%' }}
                placeholder="Type"
                allowClear
                value={value || undefined}
                onChange={(val) => {
                  onChange(val ?? '');
                  setSelectedFilter({ ...selectedFilter, type: val || undefined });
                }}
                options={[
                  { value: '', label: 'All' },
                  ...contentTypes.map((t) => ({ value: t.value, label: t.name })),
                ]}
              />
            )}
          />
        </Col>
        <Col xs={24} md={4}>
          <Controller
            name="status"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Select
                size="large"
                style={{ width: '100%' }}
                placeholder="Status"
                allowClear
                value={value || undefined}
                onChange={(val) => {
                  onChange(val ?? '');
                  setSelectedFilter({ ...selectedFilter, status: val || undefined });
                }}
                options={[
                  { value: '', label: 'All' },
                  ...allStatus.map((s) => ({ value: s.value, label: s.name })),
                ]}
              />
            )}
          />
        </Col>
        <Col xs={24} md={4}>
          <AlumlyButton
            label="rxvWhite"
            fullWidth
            onClick={resetSearchAndFilter}
          >
            Reset filters
          </AlumlyButton>
        </Col>
      </Row>
    </div>
  );
};

export default FormFilterFeaturedContentList;
